import Vue from 'vue'
import {
	Button,
	Cell,
	Field,
	Toast
} from 'vant';

Vue.use(Button)
Vue.use(Cell)
Vue.use(Field)
Vue.use(Toast)


Vue.prototype.$Toast = Toast;
